import { OrderedMap } from 'immutable';

export const FILTERS_MAP = new OrderedMap({
  owners: 'Owner',
  builds: 'Build',
  oses: 'OS',
  browsers: 'Browser',
  tags: 'Tag',
});

export const OVERVIEW_FILTERS_MAP = new OrderedMap({
  owners: 'Owner',
  builds: 'Build',
  oses: 'OS',
  browsers: 'Browser',
});
